import { render, staticRenderFns } from "./TableBlueHead.vue?vue&type=template&id=3a532f6b&scoped=true&"
import script from "./TableBlueHead.vue?vue&type=script&lang=js&"
export * from "./TableBlueHead.vue?vue&type=script&lang=js&"
import style0 from "./TableBlueHead.vue?vue&type=style&index=0&id=3a532f6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a532f6b",
  null
  
)

export default component.exports